import { useAppSelector } from 'application/providers/StoreProvider';
import { selectIsReadyToUseLK } from 'application/store/slices/accountSlice/selectors';

export const useAccountIsReadyToUseLK = () => {
  const isReady = useAppSelector(selectIsReadyToUseLK);

  return isReady;
};
